import React, { useEffect, useState } from "react";

import {
    Box,
    LinearProgress,
    linearProgressClasses,
    Tooltip,
    Typography
} from "@mui/material";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import InfoIcon from '@mui/icons-material/Info';
import { styled } from '@mui/material/styles';

const getProgressColor = (value) => {
    if (value <= 35) {
        // Red (rgb(200,12,12)) -> hsl(0, 89%, 41%)
        return `hsl(0, 89%, 41%)`;
    } else if (value <= 50) {
        // Transition from Red to Yellow (hsl(0, 89%, 41%) to hsl(57, 81%, 53%))
        const hue = 0 + ((value - 35) / (50 - 35)) * (57 - 0); // Hue interpolation
        const saturation = 89 - ((value - 35) / (50 - 35)) * (89 - 81); // Saturation interpolation
        const lightness = 41 + ((value - 35) / (50 - 35)) * (53 - 41); // Lightness interpolation
        return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    } else if (value < 100) {
        // Transition from Yellow to Lime (hsl(57, 81%, 53%) to hsl(80, 90%, 50%))
        const hue = 57 + ((value - 50) / (99 - 50)) * (80 - 57); // Hue interpolation
        const saturation = 81 + ((value - 50) / (99 - 50)) * (90 - 81); // Saturation interpolation
        const lightness = 53 - ((value - 50) / (99 - 50)) * (53 - 50); // Lightness interpolation
        return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    } else {
        // Green (rgb(30,245,0)) -> hsl(114, 100%, 48%)
        return `hsl(114, 100%, 48%)`;
    }
};

const StyledProgress = styled(LinearProgress)(({ theme }) => ({
    height: 5,
    borderRadius: 5,
    width: '100%',
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: 'rgb(60, 60, 60)'
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
    }
}))

export default function LinkSummaryProgress(props) {
    const { source, summary } = props

    
    const [linkPercent, setLinkPercent] = useState(0)

    useEffect(() => {
        const percent = Math.floor(((summary?.link ?? 0)/(summary?.media ?? 0)) * 100)
        if(isNaN(percent) || !isFinite(percent)){
            setLinkPercent(0)
        }
        else{
            setLinkPercent(percent)
        }
        
    }, [summary])

    return (
        <Box
            display='flex'
            flexDirection='column'
        >
            <Box
                display='flex'
                flexDirection='row'
                justifyContent='space-between'
                sx={{
                    paddingY: 1
                }}
            >
                <Box display='flex' flexDirection='row' alignItems='center'>
                    <Typography sx={{ fontSize: '12px', fontWeight: '600'}}>{source}</Typography>
                    <Box
                        sx={{
                            alignItems: 'center',
                            paddingX: '4px'
                        }}
                    >
                        <Tooltip
                            arrow
                            title={
                            <Box>
                                <Box>
                                    <Typography sx={{ fontSize: '10px' }}>{summary?.link ?? 0}/{summary?.total ?? 0} Metadata Linked</Typography>
                                </Box>
                                <Box>
                                    <Typography sx={{ fontSize: '10px' }}>{summary?.link ?? 0}/{summary?.media ?? 0} Media Linked</Typography>
                                </Box>
                            </Box>
                            }
                        >
                            <InfoIcon sx={{ fontSize: '12px', color: 'rgb(125, 125, 125)' }} />
                        </Tooltip>
                    </Box>
                </Box>
                <Box display='flex' flexDirection='row' alignItems='center'>
                    {linkPercent >= 100
                    ?
                        <CheckCircleOutlineIcon sx={{ fontSize: '12px', color: 'rgb(114, 214, 73)' }} />
                    :
                        <></>
                    }
                    <Typography sx={{ fontSize: '12px', fontWeight: '300'}}>{linkPercent}%</Typography>
                </Box>
            </Box>
            <Box
                display='flex'
                flexDirection='row'
                alignItems='center'
            >
                <StyledProgress
                    variant='determinate'
                    value={linkPercent}
                    sx={{
                        "& .MuiLinearProgress-bar": {
                            backgroundColor: getProgressColor(linkPercent),
                        },
                    }}
                />
            </Box>
            <Box
                display='flex'
                justifyContent='flex-end'
                sx={{
                    paddingY: 1
                }}
            >
                <Typography sx={{ display: 'flex', justifyContent: 'flex-end', fontSize: '12px', fontWeight: '300', color: 'rgb(150, 150, 150)' }}>{summary?.link ?? 0}/{summary?.media ?? 0}</Typography>
            </Box>
        </Box>
    )
}